<template>
  <cite v-if="!!name" v-editable="blok">
    <strong>
      {{ name }}
    </strong>
    <span v-if="role"> , {{ role }} </span>
    <span v-if="organisation"> , {{ organisation }} </span>
  </cite>
</template>

<script setup lang="ts">
import type { InlineCitationStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: InlineCitationStoryblok
}>()
const name = computed(() => props.blok.citation_name || '')
const role = computed(() => props.blok.citation_role || '')
const organisation = computed(() => props.blok.citation_organisation || '')
</script>

<style lang="less">
//
</style>
